"use client";

import { Check, ArrowRight } from "lucide-react";
import { Section } from "./Section";
import { MagneticButton } from "./MagneticButton";

const perks = [
  "Full academic year, all programs included",
  "Up to 40% needs-based scholarships",
  "1:8 teacher-student ratio",
  "Free campus tour & shadow day",
];

export function EnrollCard() {
  return (
    <Section id="enroll" className="bg-cream">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="relative overflow-hidden rounded-[2rem] bg-navy-grain p-10 text-primary-foreground shadow-[var(--shadow-card)] md:p-16">
          <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-gold/30 blur-3xl" />
          <div className="absolute -left-16 -bottom-24 h-72 w-72 rounded-full bg-gold/10 blur-3xl" />

          <div className="relative grid grid-cols-1 gap-12 lg:grid-cols-5">
            <div className="lg:col-span-3">
              <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.2em] text-gold">
                ● 38 spots remaining · Fall 2026
              </span>
              <h2 className="mt-6 text-balance font-display text-4xl font-extrabold leading-[1.05] md:text-6xl">
                Your child's{" "}
                <span className="font-serif-body italic font-medium text-gold">
                  best year ever
                </span>{" "}
                begins with one application.
              </h2>
              <p className="mt-6 max-w-xl font-serif-body text-xl text-white/75">
                Applications close June 30. Scholarships are reviewed on a
                rolling basis — early applicants are prioritised.
              </p>

              <div className="mt-10 flex flex-wrap items-center gap-5">
                <MagneticButton href="#" size="lg">
                  Secure Your Spot
                  <ArrowRight className="h-4 w-4" />
                </MagneticButton>
                <a
                  href="#"
                  className="font-display text-xs font-bold uppercase tracking-[0.2em] text-white/80 underline-offset-4 hover:text-gold hover:underline"
                >
                  Or book a tour →
                </a>
              </div>
            </div>

            <div className="lg:col-span-2">
              <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur">
                <p className="font-display text-[11px] font-bold uppercase tracking-[0.25em] text-gold">
                  Tuition · 2026
                </p>
                <div className="mt-4 flex flex-wrap items-baseline gap-2">
                  <span className="font-display text-4xl font-extrabold md:text-5xl">$18,400</span>
                  <span className="text-sm text-white/60">/ year</span>
                </div>
                <p className="mt-1 font-serif-body text-sm italic text-white/60">
                  Average after scholarship: $11,000
                </p>

                <ul className="mt-7 space-y-3">
                  {perks.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-sm text-white/85">
                      <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-gold text-navy-deep">
                        <Check className="h-3 w-3" strokeWidth={3} />
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
